import React from 'react';
import PropTypes from 'prop-types';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {I18n} from '../../../I18n/components/deleteModal';

const DeleteModal = props => {
    return (
        <Modal className="del-modal" isOpen={props.isOpen} toggle={props.toggle}>
            <ModalHeader>{I18n[props.lang].sure}</ModalHeader>
            <ModalBody>
                <Button color="danger" className="ml-1" onClick={props.onDelete}>{I18n[props.lang].delete}</Button>
                <Button color="secondary" className="ml-1" onClick={props.toggle}>{I18n[props.lang].cancel}</Button>
            </ModalBody>
        </Modal>
    )
};

DeleteModal.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    onDelete: PropTypes.func,
    lang: PropTypes.string
};

export default DeleteModal;


// WEBPACK FOOTER //
// ./src/components/Promo/DeleteModal/DeleteModal.js